import { hasPermission } from '@/utils/configFilter';

/**
 * 用法
 * v-permission:User.Update
 * 或者
 * v-permission="'Update:User'"
 */
export default {
  inserted: (el, binding) => {
    const { value, arg, modifiers } = binding;
    let requirePermission;
    if (value) {
      requirePermission = value;
    } else {
      requirePermission = Object.keys(modifiers).map(action => `${action}:${arg}`)[0];
    }
    if (!hasPermission(requirePermission)) {
      el.parentNode.removeChild(el);
    }
  },
};
